export const APP_NAME_DEAL_CENTRAL = 'CMD';
export const APP_NAME_AMD = 'AMD';
export const APP_NAME_DEAL_STARTER = 'Deal Starter';
export const APP_NAME_CREDIT_APP = 'Credit App';

export const APP_NAME_SHOWROOM = 'Showroom';
